<template>
  <div>
    <section class="main text-white" style="margin-top: 1px">
      <div class="home-section d-flex flex-column flex-md-row mb-5">
        <div
          class="col-12 col-md-5 d-flex flex-column justify-content-center align-items-start p-3"
        >
          <h1 class="f-secondary t-secondary p-2">
            Make your health career a reality
          </h1>
          <div class="f-primary p-2 line-height-30 mb-3">
            Welcome to the brand-new platform built for you and your career.
            Whether you’re a physician, nurse, or allied health professional,
            you’ll get access to relevant opportunities instantly - so you can
            spend less time searching, and more time advancing your
            international health and social care career.
          </div>
          <div class="d-flex justify-content-start p-2">
            <button class="btn btn-primary" @click="goToRegister()">Register Now</button>
          </div>
        </div>
        <div class="col-12 col-md-7 p-0">
          <img
            src="../../../public/img/stm/carrer-pathways-hero.png"
            class="img-fluid"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { routeToWebRegister } from "../../helpers/helper";

export default {
  methods: {
    goToRegister() {
      routeToWebRegister(this.$router);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../src/assets/scss/stm.scss";
</style>
